<template>
    <div style="display:flex;height:100%;">
        <div class="left-tree">
            <div
                style="background:#4A4C4F;padding:10px 5px;display: flex;justify-content: space-between;flex-wrap: wrap;">
                <div>
                    <span>设备导航</span>
                    <i class="el-icon-search" @click="showSearch" style="padding-left:15px;" v-if="!isFold"></i>
                </div>
                <span style="display:inline-block;" @click="toggle">
                    <i :class="[isFoldClass]"></i>
                </span>
            </div>
            <el-input v-if="showSearchBox" clearable placeholder="输入关键字进行过滤" v-model="filterText">
            </el-input>
            <div class="tree-div">
                <tree :type="'warning'" :data="treeData" :currentKey="currentKey"
                    :isDefaultExpandFirst="isDefaultExpandFirst" @clickNode="clickNode" ref="trees"
                    v-if="treeData.length != 0"></tree>
            </div>
        </div>
        <div class="main-area">
            <div class="sub-tabs warning-tabs">
                <el-tabs v-model="activeTab" class="site-tabs-ul" @tab-click="clickTabs">
                    <el-tab-pane label="测点事件" name="event"></el-tab-pane>
                    <el-tab-pane label="测点报警" name="chart"></el-tab-pane>
                    <el-tab-pane label="传感器报警" name="list"></el-tab-pane>
                    <el-tab-pane label="自检列表" name="selfcheck"></el-tab-pane>
                </el-tabs>
            </div>
            <!--传感器报警-->
            <div v-if="activeTab == 'list'" style="height:calc(100% - 160px);">
                <div class="search-content">
                    <el-form :inline="true" :model="searchForm" label-width="70px">
                        <el-form-item label="时间范围" required>
                            <el-date-picker v-model="dataRange" @change="selectDate" type="datetimerange"
                                start-placeholder="开始日期" end-placeholder="结束日期" clearable>
                            </el-date-picker>
                        </el-form-item></br>
                        <el-form-item label="测点名称">
                            <el-input v-model="searchForm.point_name" placeholder="请输入关键字" clearable style="width:180px;"></el-input>
                        </el-form-item>
                        <el-form-item label="报警状态">
                            <el-select v-model="searchForm.alarm_level" placeholder="请选择" clearable style="width:150px;">
                                <el-option label="全部" value=""></el-option>
                                <el-option label="预警" value="1"></el-option>
                                <el-option label="报警" value="2"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="处理情况">
                            <el-select v-model="searchForm.processed_num" placeholder="请选择" clearable style="width:150px;">
                                <el-option label="全部" value=""></el-option>
                                <el-option label="未处理" value=0></el-option>
                                <el-option label="手动处理" value=1></el-option>
                                <el-option label="自动处理" value=2></el-option>
                            </el-select>
                        </el-form-item></br>
                        <el-form-item label="报警描述">
                            <el-select v-model="searchForm.alarm_describe" placeholder="请选择" clearable style="width:180px;">
                                <el-option v-for="(value,key) in sensorAlarmDescribeDict" :label="value" :value="key" :key="key"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="传感器类型">
                            <el-select v-model="searchForm.sensor_type" placeholder="请选择" clearable style="width:150px;">
                                <el-option v-for="item in sensorTypeList" :label="item.label" :value="item.type" :key="item.type"></el-option>
                            </el-select>
                        </el-form-item>
                        <div class="btn-group">
                            <el-button class="small-btn" @click="showExportDialog = true; alarm_type = 1">导出</el-button>
                            <el-button class="small-btn" @click="queryList">查询</el-button>
                            <el-button class="small-btn" @click="doReset">重置</el-button>
                        </div>
                    </el-form>
                </div>
                <div class="table-content">
                    <el-table :data="tableData"
                        highlight-current-row
                        style="width: 100%"
                        v-loading="loading"
                        element-loading-text="拼命加载中"
                        element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
                        <!-- <el-table-column header-align="center" align="center" type="selection" width="55"></el-table-column> -->
                        <el-table-column label="序号" align="center" type="index" width="50"></el-table-column>
                        <el-table-column align="center" prop="equipment_name" label="设备名称" :min-width="'200px'" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="point_name" align="center" label="测点名称" :min-width="'200px'" show-overflow-tooltip></el-table-column>
                        <el-table-column align="center" prop="sensor_type" label="传感器类型" :min-width="'130px'">
                            <template slot-scope="props">
                                {{sensorTypeDic[props.row.sensor_type]}}
                            </template>
                        </el-table-column>
                        <el-table-column prop="update_time" align="center" label="报警时间" width="150">
                            <template slot-scope="props">
                                <p>{{ $moment(props.row.update_time).format("YYYY-MM-DD HH:mm:ss") }}</p>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" label="报警状态">
                            <template slot-scope="props">
                                <p>{{ sensorAlarmLevel[props.row.alarm_level] }}</p>
                            </template>
                        </el-table-column>
                        <el-table-column prop="alarm_describe" align="center" label="状态描述">
                            <template slot-scope="props">
                                <p>{{ sensorAlarmDescribeDict[props.row.alarm_describe] }}</p>
                            </template>
                        </el-table-column>
                        <el-table-column prop="recovery_time" align="center" label="报警恢复时间" width="150">
                            <template slot-scope="props">
                                <p>{{ props.row.recovery_time? $moment(props.row.recovery_time).format("YYYY-MM-DD HH:mm:ss") : '-'}}</p>
                            </template>
                        </el-table-column>
                        <el-table-column prop="operator" align="center" label="处理情况">
                            <template slot-scope="props">
                                <p>{{ processedNumDict[props.row.processed_num]}}</p>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" label="操作" :min-width="'100px'">
                            <template slot-scope="scope">
                                <el-button type="text" size="mini" @click="handle(scope.row)">确认</el-button>
                                <!-- <el-button type="text" size="mini" @click="showChart">查看</el-button> -->
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                        :current-page="currentPage" :page-sizes="[5, 10, 20, 50]" prev-text="上一页" next-text="下一页"
                        :page-size="size" layout="total, sizes, prev, pager, next, jumper" :total="total">
                    </el-pagination>
                </div>
            </div>

            <!--测点报警-->
            <div v-if="activeTab == 'chart'" style="height:calc(100% - 160px);">
                <div class="search-content">
                    <el-form :inline="true" :model="searchForm" label-width="70px">
                        <el-form-item label="时间范围" required>
                            <el-date-picker v-model="dataRange" @change="selectDate" type="datetimerange"
                                start-placeholder="开始日期" end-placeholder="结束日期" clearable>
                            </el-date-picker>
                        </el-form-item></br>
                        <el-form-item label="测点名称" v-if="!showStat || currentNodeInfo.type === 'equipment'">
                            <el-input v-model="searchForm.point_name" placeholder="请输入关键字" clearable style="width:180px;"></el-input>
                        </el-form-item>
                        <el-form-item label="报警状态">
                            <el-select v-model="searchForm.alarm_level" placeholder="请选择" clearable style="width:150px;">
                                <el-option label="全部" value=""></el-option>
                                <el-option label="诊断预警" value="1"></el-option>
                                <el-option label="诊断报警" value="2"></el-option>
                                <el-option label="长期趋势预警" value="3"></el-option>
                                <el-option label="长期趋势报警" value="4"></el-option>
                                <el-option label="短期趋势预警" value="5"></el-option>
                                <el-option label="短期趋势报警" value="6"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="处理情况">
                            <el-select v-model="searchForm.is_processed" placeholder="请选择" clearable style="width:150px;">
                                <el-option label="全部" value=""></el-option>
                                <el-option label="已处理" value="true"></el-option>
                                <el-option label="未处理" value="false"></el-option>
                            </el-select>
                        </el-form-item></br>
                        <el-form-item label="状态描述">
                            <el-select v-model="searchForm.alarm_describe" placeholder="请选择" clearable style="width:180px;">
                                <el-option v-for="(value, key) in alarmDescribeDict" :label="value" :value="key" :key="key"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="传感器类型">
                            <el-select v-model="searchForm.sensor_type" placeholder="请选择" clearable style="width:150px;">
                                <el-option v-for="item in sensorTypeList" :label="item.label" :value="item.type" :key="item.type"></el-option>
                            </el-select>
                        </el-form-item>
                        <div class="btn-group">
                            <el-button class="small-btn" @click="showExportDialog = true; alarm_type = 2">导出</el-button>
                            <el-button class="small-btn" @click="toggleStatList">{{ showStat ? '列表' : '统计' }}</el-button>
                            <el-button class="small-btn" @click="queryList">查询</el-button>
                            <el-button class="small-btn" @click="doReset">重置</el-button>
                        </div>
                    </el-form>
                </div>
                <div class="table-content">
                    <div class="stat-card" v-if="showStat">
                        <div class="stat-icon">
                            <i class="el-icon-bell"></i>
                        </div>
                        <div class="stat-info">
                            <span class="stat-label">{{ currentNodeInfo.label || '' }}报警总数</span>
                            <div class="stat-value-wrap">
                                <span class="stat-value" :style="{ color: total > 0 ? '#ef4444' : '#22c55e' }">{{ total }}</span>
                                <span class="stat-unit">次</span>
                            </div>
                        </div>
                    </div>
                    <el-table v-if="!showStat" :data="tableData"
                        highlight-current-row
                        style="width: 100%"
                        v-loading="loading" element-loading-text="拼命加载中"
                        element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
                        <!-- <el-table-column header-align="center" align="center" type="selection" width="55"></el-table-column> -->
                        <el-table-column label="序号" align="center" type="index" width="50"></el-table-column>
                        <el-table-column align="center" :min-width="'200px'" show-overflow-tooltip label="设备名称">
                            <template slot-scope="props">
                                {{ props.row.equipment_name != null ? props.row.equipment_name : '-' }}
                            </template>
                        </el-table-column>
                        <el-table-column align="center" :min-width="'200px'" show-overflow-tooltip label="测点名称">
                            <template slot-scope="props">
                                {{ props.row.point_name != null ? props.row.point_name : '-' }}
                            </template>
                        </el-table-column>
                        <el-table-column align="center" label="传感器类型">
                            <template slot-scope="props">
                                {{ sensorTypeDic[props.row.sensor_type] != null ? sensorTypeDic[props.row.sensor_type] : '-' }}
                            </template>
                        </el-table-column>
                        <el-table-column align="center" width="150" label="报警时间">
                            <template slot-scope="props">
                                {{ props.row.update_time != null ? props.row.update_time : '-' }}
                            </template>
                        </el-table-column>
                        <el-table-column align="center" label="报警状态">
                            <template slot-scope="props">
                                <p>{{ alarmLevel[props.row.alarm_level] != null ? alarmLevel[props.row.alarm_level] : '-' }}</p>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" label="状态描述">
                            <template slot-scope="props">
                                <p>{{ alarmDescribeDict[props.row.alarm_describe] != null ? alarmDescribeDict[props.row.alarm_describe] : '-' }}</p>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" label="处理情况">
                            <template slot-scope="props">
                                <p>{{ props.row.is_processed != null ? (props.row.is_processed ? '已处理' : '未处理') : '-' }}</p>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" label="操作" width="100px">
                            <template slot-scope="scope">
                                <el-button type="text" size="mini" @click="handle(scope.row)">确认</el-button>
                                <el-button type="text" size="mini" @click="showChart(scope.row)">查看</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-table v-else :data="statTableData"
                        highlight-current-row
                        style="width: 100%"
                        v-loading="loading" element-loading-text="拼命加载中"
                        element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
                        <el-table-column label="序号" align="center" type="index" width="50"></el-table-column>
                        <el-table-column align="center" :min-width="'150px'" show-overflow-tooltip label="公司名称">
                            <template slot-scope="props">
                                {{ props.row.customer_name != null ? props.row.customer_name : '-' }}
                            </template>
                        </el-table-column>
                        <el-table-column align="center" :min-width="'150px'" show-overflow-tooltip label="站点名称">
                            <template slot-scope="props">
                                {{ props.row.site_name != null ? props.row.site_name : '-' }}
                            </template>
                        </el-table-column>
                        <el-table-column align="center" :min-width="'200px'" show-overflow-tooltip label="设备名称">
                            <template slot-scope="props">
                                {{ props.row.equipment_name != null ? props.row.equipment_name : '-' }}
                            </template>
                        </el-table-column>
                        <el-table-column align="center" :min-width="'200px'" show-overflow-tooltip label="测点名称">
                            <template slot-scope="props">
                                {{ props.row.point_name != null ? props.row.point_name : '-' }}
                            </template>
                        </el-table-column>
                        <el-table-column align="center" width="100" label="报警总数">
                            <template slot-scope="props">
                                <span :style="{ color: props.row.total > 0 ? '#ef4444' : '#22c55e' }">{{ props.row.total != null ? props.row.total + '次' : '-' }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" width="100" label="未处理数">
                            <template slot-scope="props">
                                <span :style="{ color: props.row.unprocessed > 0 ? '#ef4444' : '#22c55e' }">{{ props.row.unprocessed != null ? props.row.unprocessed + '次' : '-' }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" width="100" label="已处理数">
                            <template slot-scope="props">
                                <span :style="{ color: props.row.processed > 0 ? '#ef4444' : '#22c55e' }">{{ props.row.processed != null ? props.row.processed + '次' : '-' }}</span>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-pagination v-if="!showStat" @size-change="handleSizeChange" @current-change="handleCurrentChange"
                        :current-page="currentPage" :page-sizes="[5, 10, 20, 50]" prev-text="上一页" next-text="下一页"
                        :page-size="size" layout="total, sizes, prev, pager, next, jumper" :total="total">
                    </el-pagination>
                </div>
            </div>

            <!--自检列表-->
            <div v-if="activeTab == 'selfcheck'" style="height:calc(100% - 160px);">
                <div class="search-content">
                    <el-form :inline="true" :model="selfCheckSearchForm" label-width="70px">
                        <el-form-item label="站点名称">
                            <el-input v-model="selfCheckSearchForm.site_name" placeholder="请输入关键字" clearable style="width:180px;"></el-input>
                        </el-form-item>
                        <el-form-item label="设备名称">
                            <el-input v-model="selfCheckSearchForm.equipment_name" placeholder="请输入关键字" clearable style="width:180px;"></el-input>
                        </el-form-item>
                        <el-form-item label="测点名称">
                            <el-input v-model="selfCheckSearchForm.point_name" placeholder="请输入关键字" clearable style="width:180px;"></el-input>
                        </el-form-item></br>
                        <el-form-item label="传感器类型">
                            <el-select v-model="selfCheckSearchForm.sensor_type" placeholder="请选择" clearable style="width:150px;">
                                <el-option v-for="item in sensorTypeList" :label="item.label" :value="item.type" :key="item.type"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="通讯状态">
                            <el-select v-model="selfCheckSearchForm.online_status" placeholder="请选择" clearable style="width:150px;">
                                <el-option label="全部" value=""></el-option>
                                <el-option label="在线" :value="1"></el-option>
                                <el-option label="离线" :value="0"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="采集状态">
                            <el-select v-model="selfCheckSearchForm.sampling_check_status" placeholder="请选择" clearable style="width:150px;">
                                <el-option label="全部" value=""></el-option>
                                <el-option label="正常" :value="1"></el-option>
                                <el-option label="异常" :value="0"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="健康状态">
                            <el-select v-model="selfCheckSearchForm.health_status" placeholder="请选择" clearable style="width:150px;">
                                <el-option label="全部" value=""></el-option>
                                <el-option label="正常" :value="1"></el-option>
                                <el-option label="故障" :value="0"></el-option>
                            </el-select>
                        </el-form-item>
                        <div class="btn-group">
                            <el-button class="small-btn" @click="querySelfCheckList">查询</el-button>
                            <el-button class="small-btn" @click="doSelfCheckReset">重置</el-button>
                        </div>
                    </el-form>
                </div>
                <div class="table-content">
                    <el-table :data="selfCheckTableData"
                        highlight-current-row
                        style="width: 100%"
                        v-loading="loading" element-loading-text="拼命加载中"
                        element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
                        <el-table-column label="序号" align="center" type="index" width="50"></el-table-column>
                        <el-table-column align="center" prop="site_name" :min-width="'150px'" show-overflow-tooltip label="站点名称"></el-table-column>
                        <el-table-column align="center" prop="equipment_name" :min-width="'200px'" show-overflow-tooltip label="设备名称"></el-table-column>
                        <el-table-column prop="point_name" align="center" :min-width="'200px'" show-overflow-tooltip label="测点名称"></el-table-column>
                        <el-table-column align="center" prop="sensor_type" label="传感器类型" :min-width="'130px'">
                            <template slot-scope="props">
                                {{sensorTypeDic[props.row.sensor_type]}}
                            </template>
                        </el-table-column>
                        <el-table-column align="center" label="健康状态" :min-width="'100px'">
                            <template slot-scope="props">
                                <span :style="{ color: props.row.health_status ? '#22c55e' : '#ef4444' }">
                                    {{ props.row.health_status ? '正常' : '故障' }}
                                </span>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" label="状态描述" :min-width="'220px'">
                            <template slot-scope="props">
                                <p :style="{ color: props.row.online_status === 1 ? '#22c55e' : '#ef4444' }">通讯状态：{{ props.row.online_status === 1 ? '在线' : '离线' }}</p>
                                <p :style="{ color: props.row.sampling_check_status === 1 ? '#22c55e' : '#ef4444' }">采集状态：{{ props.row.online_status === 0? '--' : (props.row.sampling_check_status === 1 ? '正常' : '异常') }}</p>
                            </template>
                        </el-table-column>
                        <el-table-column prop="create_time" align="center" :min-width="'200px'" show-overflow-tooltip label="自检时间"></el-table-column>
                    </el-table>
                    <el-pagination @size-change="handleSelfCheckSizeChange" @current-change="handleSelfCheckCurrentChange"
                        :current-page="selfCheckCurrentPage" :page-sizes="[5, 10, 20, 50]" prev-text="上一页" next-text="下一页"
                        :page-size="selfCheckSize" layout="total, sizes, prev, pager, next, jumper" :total="selfCheckTotal">
                    </el-pagination>
                </div>
            </div>

            <!--事件列表-->
            <div v-if="activeTab == 'event'" style="height:calc(100% - 160px);">
                <div class="search-content">
                    <el-form :inline="true" :model="eventSearchForm" label-width="70px">
                        <el-form-item label="时间范围" required>
                            <el-date-picker v-model="eventDateRange" @change="selectEventDate" type="datetimerange"
                                start-placeholder="开始日期" end-placeholder="结束日期" clearable>
                            </el-date-picker>
                        </el-form-item></br>
                        <el-form-item label="测点名称">
                            <el-input v-model="eventSearchForm.point_name" placeholder="请输入关键字" clearable style="width:180px;"></el-input>
                        </el-form-item>
                        <el-form-item label="报警等级">
                            <el-select v-model="eventSearchForm.alarm_level" placeholder="请选择" clearable style="width:150px;">
                                <el-option label="全部" value=""></el-option>
                                <el-option label="预警" value="1"></el-option>
                                <el-option label="报警" value="2"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="传感器类型">
                            <el-select v-model="eventSearchForm.sensor_type" placeholder="请选择" clearable style="width:150px;">
                                <el-option v-for="item in sensorTypeList" :label="item.label" :value="item.type" :key="item.type"></el-option>
                            </el-select>
                        </el-form-item>
                        <div class="btn-group">
                            <el-button class="small-btn" @click="showEventExportDialog = true">导出</el-button>
                            <el-button class="small-btn" @click="queryEventList">查询</el-button>
                            <el-button class="small-btn" @click="doEventReset">重置</el-button>
                        </div>
                    </el-form>
                </div>
                <div class="table-content">
                    <el-table :data="eventTableData"
                        highlight-current-row
                        style="width: 100%"
                        v-loading="loading" element-loading-text="拼命加载中"
                        element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
                        <el-table-column label="序号" align="center" type="index" width="50"></el-table-column>
                        <el-table-column align="center" prop="site_name"  :min-width="'150px'" show-overflow-tooltip
                            label="站点名称"></el-table-column>
                        <el-table-column align="center" prop="equipment_name"  :min-width="'200px'" show-overflow-tooltip
                            label="设备名称"></el-table-column>
                        <el-table-column prop="point_name" align="center"  :min-width="'200px'" show-overflow-tooltip
                            label="测点名称"></el-table-column>
                        <el-table-column align="center" prop="sensor_type" label="传感器类型">
                            <template slot-scope="props">
                                {{sensorTypeDic[props.row.sensor_type]}}
                            </template>
                        </el-table-column>
                        <el-table-column align="center" label="事件描述">
                            <template slot-scope="props">
                                <p>{{ alarmDescribeDict[props.row.event_describe] || '-' }}</p>
                            </template>
                        </el-table-column>
                        <el-table-column prop="create_date" align="center" width="150" label="上传时间"></el-table-column>
                        <el-table-column align="center" label="操作" width="100px">
                            <template slot-scope="scope">
                                <el-button type="text" size="mini" @click="showEventDetail(scope.row)">查看</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-pagination @size-change="handleEventSizeChange" @current-change="handleEventCurrentChange"
                        :current-page="eventCurrentPage" :page-sizes="[5, 10, 20, 50]" prev-text="上一页" next-text="下一页"
                        :page-size="eventSize" layout="total, sizes, prev, pager, next, jumper" :total="eventTotal">
                    </el-pagination>
                </div>
            </div>
        </div>
        <!-- 导出弹窗 -->
        <el-dialog
        title="导出时间范围"
        :visible.sync="showExportDialog"
        width="40%"
        :close-on-click-modal="false"
        class="dark-dialog"
        >
        <el-form 
            ref="exportForm" 
            :model="exportForm" 
            label-width="120px"
            :rules="formRules"
            class="dark-form"
        >

            <!-- 5. 时间范围选择 -->
            <el-form-item label="时间范围" prop="timeRange">
            <el-date-picker
                v-model="exportForm.timeRange"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                :default-time="['00:00:00', '23:59:59']"
                value-format="yyyy-MM-dd HH:mm:ss"
                class="dark-picker"
            />
            </el-form-item>
        </el-form>

        <div slot="footer" class="dialog-footer">
            <el-button @click="showExportDialog = false">取消</el-button>
            <el-button type="primary" :loading="exportLoading" @click="handleExport">确认导出</el-button>
        </div>
        </el-dialog>

        <!-- 事件导出弹窗 -->
        <el-dialog
        title="导出时间范围"
        :visible.sync="showEventExportDialog"
        width="40%"
        :close-on-click-modal="false"
        class="dark-dialog"
        >
        <el-form 
            ref="eventExportForm" 
            :model="exportForm" 
            label-width="120px"
            :rules="formRules"
            class="dark-form"
        >
            <el-form-item label="时间范围" prop="timeRange">
            <el-date-picker
                v-model="exportForm.timeRange"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                :default-time="['00:00:00', '23:59:59']"
                value-format="yyyy-MM-dd HH:mm:ss"
                class="dark-picker"
            />
            </el-form-item>
        </el-form>

        <div slot="footer" class="dialog-footer">
            <el-button @click="showEventExportDialog = false">取消</el-button>
            <el-button type="primary" @click="handleEventExport">确认导出</el-button>
        </div>
        </el-dialog>
        <div v-if="showDetails">
            <Details v-if="showDetails" :visible.sync="showDetails" :detailsInfo="detailsInfo" @clickNode="clickNode"
                @refreshTree="refreshTree"></Details>
        </div>
        <div v-if="showChartDetails">
            <chartDetails :visible.sync="showChartDetails" :dataDetails="dataDetails" :isWsUpdate="false">
            </chartDetails>
        </div>
        <div  v-if="showTrendDetails">
             <chart :visible.sync="showTrendDetails" :trendCharData="trend_char_data" :selectData="trendSelectData" :currentNode="currentNodeInfo" :total="siteTotal"></chart>
        </div>
        <div  v-if="showjx" >
            <jx  :visible.sync="showjx" :dataDetails="dataDetails"></jx>
        </div>
        <div v-if="showNearestMotorSeq">
           <NearestMotorSeq :visible.sync="showNearestMotorSeq" :dataDetails="dataDetails"></NearestMotorSeq>
        </div>

    </div>
</template>

<script>
import tree from '@/components/tree.vue'
import * as warning from '@/data/warning.js'
import * as device from '@/data/device.js'
import * as eventApi from '@/data/event.js'
import Bus from "@/util/Bus.js";
import { PDType, sensorTypeDic, alarmDescribeDict, sensorAlarmDescribeDict, alarmLevel, processedNumDict, sensorAlarmLevel} from "@/util/sensorType.js"
import {sensorTypeOptions} from "@/util/sensorType.js";

export default {
    name: '',
    components: {
        tree,
        Details: resolve => { require(['./details.vue'], resolve) },
        chartDetails: resolve => { require(['../site/chartDetails.vue'], resolve) },
        chart: resolve => {require(['../site/chart.vue'], resolve)},
        jx: resolve => {require(['../site/jx.vue'], resolve)},
        NearestMotorSeq: resolve => {require(['../site/components/NearestMotorSeq/NearestMotorSeqDialog.vue'], resolve)}
    },
    data() {
        return {
            isDefaultExpandFirst: true,
            currentKey: '',
            treeData: [],
            filterText: '',
            showSearchBox: false,
            isFold: false,
            isFoldClass: 'el-icon-s-fold',
            tableData: [],
            sensorTypeDic: sensorTypeDic,
            form: {
                name: '',
                region: '',
                date1: '',
                date2: '',
            },
            activeTab: 'chart',
            showDetails: false,
            dataRange: [],
            loading: false,
            exportLoading: false,
            alarmDescribeDict,
            sensorAlarmDescribeDict,
            alarmLevel,
            detailsInfo: {},
            currentNodeInfo: {},
            searchForm: {
                "alarm_type": 2,
                "sensor_type": "",
                "start_date": "",
                "end_data": "",
                "alarm_level": "",
                "is_processed": '',
                "alarm_describe": '',
                "processed_num": '',
                "point_name": '',
                "only_first": false
            },
            showChartDetails: false,
            dataDetails: {},
            currentPage: 1,
            size: 10,
            total: 0,
            sensorTypeList: sensorTypeOptions,
            processedNumDict,
            sensorAlarmLevel,
            showTrendDetails: false,
            trend_char_data:{},
            trendSelectData: [],
            siteTotal: 1000,
            showjx: false,
            showNearestMotorSeq: false,
            showExportDialog: false,
            showEventExportDialog: false,
            // 表单校验规则
            formRules: {
                companyId: [{ required: true, message: '请选择公司', trigger: 'change' }],
                siteId: [{ required: true, message: '请选择站点', trigger: 'change' }],
                deviceId: [{ required: true, message: '请选择设备', trigger: 'change' }],
                pointIds: [
                { required: true, message: '请至少选择一个测点', trigger: 'change' },
                { type: 'array', min: 1, message: '请至少选择一个测点', trigger: 'change' }
                ],
                timeRange: []
            },
            // 下拉选项数据（实际项目中从接口获取）
            companyList: [],   // 公司列表
            siteList: [],      // 站点列表
            deviceList: [],    // 设备列表
            pointList: [],      // 测点列表
                  // 表单数据
            exportForm: {
                timeRange: []     // 时间范围 [开始时间, 结束时间]
            },
            alarm_type: 1,
            // 事件列表相关
            eventTableData: [],
            eventCurrentPage: 1,
            eventSize: 10,
            eventTotal: 0,
            eventDateRange: [],
            eventSearchForm: {
                "point_name": "",
                "start_date": "",
                "end_date": "",
                "alarm_level": "",
                "sensor_type": ""
            },
            // 统计相关
            showStat: false,
            statTableData: [],
            // 自检列表相关
            selfCheckTableData: [],
            selfCheckCurrentPage: 1,
            selfCheckSize: 10,
            selfCheckTotal: 0,
            selfCheckSearchForm: {
                site_name: '',
                equipment_name: '',
                point_name: '',
                sensor_type: '',
                online_status: '',
                sampling_check_status: '',
                health_status: ''
            }

        }
    },
    mounted() {
        const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
        });

        try {
            this.getTreeData();
            Bus.$on('wsData', this.wsDataByWarning)
        } catch (error) {
            // 可添加错误提示：this.$message.error('加载失败，请重试')
        } finally {
            // 无论成功/失败，最终都关闭 loading
            if (loading && typeof loading.close === 'function') {
            loading.close();
            }
        }
    },
    beforeDestroy() {
        //sessionStorage.removeItem('currentNode');
        // 注销事件监听器
        Bus.$off('wsData', this.wsDataByWarning);
    },
    watch: {
        filterText(val) {
            this.$refs.trees.filterData(val);
        },
    },
    methods: {
        showExportError(err) {
            if (err && err.messageShown) {
                return;
            }
            const message = err && err.message ? err.message : err;
            this.$message.error(message || '此时间段无数据！');
        },
        handleExport() {
            if (this.exportLoading) {
                return;
            }
            const timeRange = this.exportForm && this.exportForm.timeRange || []
            const start_date = timeRange[0]
            const end_date = timeRange[1]
            
            if (!this.showStat && (!start_date || !end_date)) {
                this.$message.error('请选择完整的时间范围');
                return;
            }
            
            let obj = this.currentNodeInfo
            this.currentKey = obj.id
            let params = {}
            this.exportLoading = true;
            const outLoading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            
            if (this.showStat) {
                const data = {}
                if (start_date != null && start_date !== '') {
                    data.start_date = start_date
                }
                if (end_date != null && end_date !== '') {
                    data.end_date = end_date
                }
                if (this.alarm_type != null && this.alarm_type !== '') {
                    data.alarm_type = this.alarm_type
                }
                if (this.searchForm.alarm_level != null && this.searchForm.alarm_level !== '') {
                    data.alarm_level = this.searchForm.alarm_level
                }
                if (this.searchForm.sensor_name != null && this.searchForm.sensor_name !== '') {
                    data.sensor_name = this.searchForm.sensor_name
                }
                if (this.searchForm.sensor_type != null && this.searchForm.sensor_type !== '') {
                    data.sensor_type = this.searchForm.sensor_type
                }
                params = {
                    data: data
                }
                let exportFunc = null
                if (obj.type == "customer") {
                    params.customer_id = obj.id
                    exportFunc = warning.customerAlarmStatExport
                } else if (obj.type == "site") {
                    params.site_id = obj.id
                    exportFunc = warning.siteAlarmStatExport
                } else if (obj.type == "equipment") {
                    params.equipment_id = obj.id
                    exportFunc = warning.equipmentAlarmStatExport
                }
                exportFunc(params).then((res) => {
                    return res
                }).catch(err => {
                    console.error('导出失败', err);
                    this.showExportError(err);
                }).finally(() => {
                    this.exportLoading = false;
                    outLoading.close();
                    this.showExportDialog = false;
                    this.exportForm = { /* 重置表单 */ };
                });
            } else {
                let data = {}
                if (start_date != null && start_date !== '') {
                    data.start_date = start_date
                }
                if (end_date != null && end_date !== '') {
                    data.end_date = end_date
                }
                if (this.alarm_type != null && this.alarm_type !== '') {
                    data.alarm_type = this.alarm_type
                }
                
                if (obj.type == "customer") {
                    params = {
                        customer_id: obj.id,
                        data: data
                    }
                } else if (obj.type == "site") {
                    data.site_id = obj.id
                    params = {
                        customer_id: obj.parent_id,
                        data: data
                    }
                } else if (obj.type == "equipment") {
                    let customer_id;
                    this.treeData.forEach(item => {
                        item.children.forEach(site => {
                            if (site.id == obj.parent_id) {
                                customer_id = item.id;
                            }
                        })
                    })
                    data.equipment_id = obj.id
                    params = {
                        customer_id: customer_id,
                        data: data
                    }
                }
                warning.exportAlarmData(params).then((res) => {
                    return res
                }).catch(err => {
                    console.error('导出失败', err);
                    this.showExportError(err);
                }).finally(() => {
                    this.exportLoading = false;
                    outLoading.close();
                    this.showExportDialog = false;
                    this.exportForm = { /* 重置表单 */ };
                });
            }
        },
        wsDataByWarning(target) {
            target = JSON.parse(target);
            let alarmData = target.message.data.alarm_data;
            if (alarmData) {
                if (alarmData.update_date) {
                    alarmData.update_time = alarmData.update_date
                }
                //判断当前测点
                if (this.currentNodeInfo.type == 'site' && this.currentNodeInfo.id == alarmData.site_id) {
                    if (this.tableData.length >= 10) {
                        this.tableData.pop();
                    }
                    this.tableData.unshift(alarmData)
                } else if (this.currentNodeInfo.type == 'equipment' && this.currentNodeInfo.id == alarmData.equipment_id) {
                    if (this.tableData.length >= 10) {
                        this.tableData.pop();
                    }
                    this.tableData.unshift(alarmData)
                }
            }
        },
        handleSizeChange(val) {
            this.size = val;
            this.queryList();
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.queryList();
        },
        clickTabs(tab) {
            this.reset();
            this.currentPage = 1;
            if (tab.name == 'chart') {
                this.searchForm.alarm_type = 2;
            } else if (tab.name == 'list') {
                this.searchForm.alarm_type = 1;
            } else if (tab.name == 'event') {
                this.eventCurrentPage = 1;
                this.queryEventList();
                return;
            } else if (tab.name == 'selfcheck') {
                this.selfCheckCurrentPage = 1;
                this.resetSelfCheckForm();
                this.querySelfCheckList();
                return;
            }
            this.clickNode(this.currentNodeInfo)
        },
        queryList() {
            if (this.showStat) {
                this.loading = true;
                if (this.currentNodeInfo.type == 'customer') {
                    this.getCustomerStat(this.currentNodeInfo.id)
                } else if (this.currentNodeInfo.type == 'site') {
                    this.getSiteStat(this.currentNodeInfo.id)
                } else if (this.currentNodeInfo.type == 'equipment') {
                    this.getEquipmentStat(this.currentNodeInfo.id)
                }
            } else {
                if (this.currentNodeInfo.type == 'customer') {
                    this.getCustomerList(this.currentNodeInfo.id)
                } else if (this.currentNodeInfo.type == 'site') {
                    this.getSiteList(this.currentNodeInfo.id)
                } else if (this.currentNodeInfo.type == 'equipment') {
                    this.getEquipmentList(this.currentNodeInfo.id)
                }
            }
        },
        toggleStatList() {
            if (this.showStat) {
                this.showStat = false;
            } else {
                if (!this.currentNodeInfo) {
                    this.$message.warning('请先选择节点');
                    return;
                }
                this.showStat = true;
                this.loading = true;
                if (this.currentNodeInfo.type == 'customer') {
                    this.getCustomerStat(this.currentNodeInfo.id)
                } else if (this.currentNodeInfo.type == 'site') {
                    this.getSiteStat(this.currentNodeInfo.id)
                } else if (this.currentNodeInfo.type == 'equipment') {
                    this.getEquipmentStat(this.currentNodeInfo.id)
                }
            }
        },
        getCustomerStat(id) {
            warning.customerAlarmStat({ customer_id: id, data: this.searchForm }).then(res => {
                this.loading = false;
                this.statTableData = res.data.stat_list;
                this.total = res.data.total;
            }).catch((err) => {
                this.loading = false;
                console.error('统计请求失败:', err);
            })
        },
        getSiteStat(id) {
            warning.siteAlarmStat({ site_id: id, data: this.searchForm }).then(res => {
                this.loading = false;
                this.statTableData = res.data.stat_list;
                this.total = res.data.total;
            }).catch((err) => {
                this.loading = false;
                console.error('统计请求失败:', err);
            })
        },
        getEquipmentStat(id) {
            warning.equipmentAlarmStat({ equipment_id: id, data: this.searchForm }).then(res => {
                this.loading = false;
                this.statTableData = res.data.stat_list;
                this.total = res.data.total;
            }).catch((err) => {
                this.loading = false;
                console.error('统计请求失败:', err);
            })
        },
        doReset() {
            this.reset()
            this.queryList();
        },
        reset() {
            this.dataRange = [];
            this.searchForm.alarm_level = '';
            this.searchForm.is_processed = '';
            this.searchForm.start_date = '';
            this.searchForm.end_date = '';
            this.searchForm.alarm_describe = '';
            this.searchForm.sensor_type = '';
            this.searchForm.processed_num = '';
            this.searchForm.point_name = '';
            this.searchForm.only_first = false;
        },
        selectDate() {
            if (this.dataRange) {
                this.searchForm.start_date = this.formatDate(this.dataRange[0])
                this.searchForm.end_date = this.formatDate(this.dataRange[1]);
            } else {
                this.searchForm.start_date = this.searchForm.end_date = ""
            }
        },
        formatDate(date) {
            return date.getFullYear() + '-' + this.timeFormat(date.getMonth() + 1) + '-' + this.timeFormat(date.getDate()) + ' ' + this.timeFormat(date.getHours()) + ':' + this.timeFormat(date.getMinutes()) + ':' + this.timeFormat(date.getSeconds());
        },
        timeFormat(v) {
            return v < 10 ? '0' + v : v
        },
        clickNode(v) {
            this.currentPage = 1;
            let obj;
            if (!v) {
                obj = this.currentNodeInfo
            } else {
                obj = v;
                this.currentNodeInfo = v;
            }
            console.log('currentNodeInfo:', this.currentNodeInfo);
            this.currentKey = obj.id
            if (this.activeTab == 'event') {
                this.eventCurrentPage = 1;
                this.queryEventList();
            } else if (this.activeTab == 'selfcheck') {
                this.selfCheckCurrentPage = 1;
                this.querySelfCheckList();
            } else {
                if (this.showStat) {
                    this.loading = true;
                    if (obj.type == "customer") {
                        this.getCustomerStat(obj.id)
                    } else if (obj.type == "site") {
                        this.getSiteStat(obj.id)
                    } else if (obj.type == "equipment") {
                        this.getEquipmentStat(obj.id)
                    }
                } else {
                    if (obj.type == "customer") {
                        this.loading = true;
                        this.getCustomerList(obj.id)
                    } else if (obj.type == "site") {
                        this.loading = true;
                        this.getSiteList(obj.id)
                    } else if (obj.type == "equipment") {
                        this.loading = true;
                        this.getEquipmentList(obj.id)
                    }
                }
            }
        },
        refreshTree() {
            if (this.searchForm.alarm_type == 1) {
                //传感器列表 确认不刷新红点数
                return;
            }
            let ids = {}
            let arr = this.treeData;
            let _this = this;
            function query(arr) {
                arr.forEach(item => {
                    if (item.id == _this.currentNodeInfo.id) {
                        item.unprocessed_num--;
                    }
                    if (item.children) {
                        query(item.children)
                    }
                })
            }
            query(arr)
        },
        showSearch() {
            this.showSearchBox = !this.showSearchBox;
        },
        toggle(v) {
            this.isFold = !this.isFold;
            let style = this.isFold ? { width: '25px' } : { width: '280px' }
            let heightStyle = this.isFold ? { height: '140px' } : { height: 'calc(100% - 160px)' }
            let treeStyle = this.isFold ? { height: 0 } : { height: "calc(100% - 40px)" }
            this.isFoldClass = this.isFold ? 'el-icon-s-unfold' : 'el-icon-s-fold'
            $('.left-tree').css(heightStyle).animate(style);
            $('.tree-div').css(treeStyle)
            this.isFold ? $('.main-area').css({ width: '100%' }) : $('.main-area').css({ width: 'calc(100% - 300px)' })
            this.showSearchBox = false
        },
        getTreeData() {
            device.queryTree().then(res => {
                if (!res) return;
                this.treeData = res.data;
                const str = sessionStorage.getItem('currentNode');
                if (this.$route.params.activeTab) {
                    this.activeTab = this.$route.params.activeTab
                }
                if (this.$route.params.searchForm) {
                    this.searchForm = this.$route.params.searchForm
                    this.dataRange = [
                        new Date(new Date(this.searchForm.start_date)), 
                        new Date(new Date(this.searchForm.end_date))
                    ]
                    if (!this.$route.params.activeTab) {
                        this.activeTab = this.searchForm.alarm_type == 1 ? 'list' : 'chart'
                    }
                }
                if (this.$route.params.selfCheckSearchForm) {
                    this.selfCheckSearchForm = Object.assign({}, this.selfCheckSearchForm, this.$route.params.selfCheckSearchForm)
                }
                //来自站点详情的红点点击
                if (this.$route.params.node) {
                    this.currentKey = this.$route.params.node.id
                    this.searchForm.is_processed = 'false'
                    this.clickNode(this.$route.params.node)
                    this.isDefaultExpandFirst = false;
                } else if (str) {
                    let obj = JSON.parse(str)
                    // if(obj.type == 'customer'){
                    //      obj = obj.children[0]
                    // }
                    this.currentKey = obj.id
                    this.isDefaultExpandFirst = false;
                    this.clickNode(obj)
                } else {
                    this.currentKey = res.data[0].children[0].id
                    this.clickNode(res.data[0].children[0])
                }
                this.$nextTick(() => {
                    this.$refs.trees.$refs.tree.setCurrentKey(this.currentKey);
                });
            })
        },
        getCustomerList(id) {
            warning.customerAlarmList({ customer_id: id, data: Object.assign(this.searchForm, { page: this.currentPage, limit: this.size }) }).then(res => {
                this.loading = false;
                this.tableData = res.data.alarm_list;
                this.total = res.data.total;
            }).catch((err) => {
                this.loading = false
            })
        },
        getSiteList(id) {
            warning.siteAlarmList({ site_id: id, data: Object.assign(this.searchForm, { page: this.currentPage, limit: this.size }) }).then(res => {
                this.loading = false;
                this.tableData = res.data.alarm_list;
                this.total = res.data.total;
            }).catch((err) => {
                this.loading = false
            })
        },
        getEquipmentList(id) {
            warning.equipmentAlarmList({ equipments_id: id, data: Object.assign(this.searchForm, { page: this.currentPage, limit: this.size }) }).then(res => {
                this.loading = false;
                this.tableData = res.data.alarm_list;
                this.total = res.data.total;
            }).catch((err) => {
                this.loading = false
            })
        },
        handle(row) {
            this.detailsInfo = row;
            this.showDetails = true;
        },
        showChart(row) {    
            let outLoading = this.$loading({
                target: '.el-dialog',          
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });   
            try {
                if (row.sensor_type === 'MECH') {
                    this.dataDetails = row;
                    this.showjx = true;
                    outLoading.close();
                    return;
                }
                if (row.sensor_type === 'MECHSEP') {
                    this.dataDetails = row;
                    this.showNearestMotorSeq = true;
                    outLoading.close();
                    return;
                }
                if ([3,4,5,6].includes(row.alarm_level)) {
                    this.trendSelectData = [{point_id: row.point_id, sensor_type: row.sensor_type, point_name: row.point_name, site_id: row.site_id}]
                    warning.getTrendAlarmDataList({trend_alarm_id: row.trend_alarm_detail_id}).then(val => {
                        this.trend_char_data = val.data
                        this.showTrendDetails = true;
                        outLoading.close();
                    }).catch(err => {
                    })

                } else {
                    let equipment_id = row.equipment_id
                    let start_date = row.update_time
                    let max_query_num = 100
                    const params = {
                        equipment_id: equipment_id,
                        body: {
                            start_date: start_date,
                            max_query_num: max_query_num
                        }
                    }
                    device.findNearData(params).then(res => {
                        const { data = [] } = res; // 解构并默认空数组，避免报错
                        
                        // 空数据提前处理
                        if (data.length === 0) {
                            this.$message.warning("历史数据已被清理");
                            outLoading.close();
                            return;
                        }

                        // 1. 提取当前传感器数据（最优先）
                        const currentSensorData = data.filter(item => 
                            item.sensor_data_id === row.sensor_data_id
                        );

                        // 2. 分离其他数据（排除当前传感器）
                        const otherData = data.filter(item => 
                            item.sensor_data_id !== row.sensor_data_id
                        );

                        // 定义局放类型常量
                        const pdTypes = ["HFCT", "UHF", "AE", "TEV", "PC"];
                        const currentType = row.sensor_type; // 当前传感器类型

                        const [sameType, pdData, remainingData] = otherData.reduce((acc, item) => {
                            const [same, pd, remaining] = acc;
                            
                            if (item.sensor_type === currentType) {
                            // 3.1 同类型（非当前传感器）
                            same.push(item);
                            } else if (pdTypes.includes(item.sensor_type)) {
                            // 3.2 局放类型（非当前类型）
                            pd.push(item);
                            } else {
                            // 3.3 剩余其他类型
                            remaining.push(item);
                            }
                            
                            return acc;
                        }, [[], [], []]); // 初始值：[同类型, 局放类型, 剩余类型]

                        // 4. 按优先级合并：自己 → 同类型 → 局放 → 剩余
                        this.dataDetails = [].concat(
                            currentSensorData,
                            sameType,
                            pdData,
                            remainingData
                        );

                        this.showChartDetails = true;
                        outLoading.close();
                    });
                }
            } catch(err) {
                outLoading.close();
                console.log('请求报警数据出错：', err)
            }
        },
        // 事件详情查看
        showEventDetail(row) {    
            let outLoading = this.$loading({
                target: '.el-dialog',          
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });   
            try {
                eventApi.getEventDetail({event_id: row.event_id}).then(res => {
                    const eventData = res.data;
                    
                    let equipment_id = row.equipment_id
                    let start_date = row.create_date
                    let max_query_num = 100
                    const params = {
                        equipment_id: equipment_id,
                        body: {
                            start_date: start_date,
                            max_query_num: max_query_num
                        }
                    }
                    device.findNearData(params).then(res => {
                        const { data = [] } = res;
                        
                        if (data.length === 0) {
                            this.$message.warning("历史数据已被清理");
                            outLoading.close();
                            return;
                        }

                        const currentSensorData = data.filter(item => 
                            item.sensor_data_id === row.sensor_data_id
                        );

                        const otherData = data.filter(item => 
                            item.sensor_data_id !== row.sensor_data_id
                        );

                        const pdTypes = ["HFCT", "UHF", "AE", "TEV", "PC"];
                        const currentType = row.sensor_type;

                        const [sameType, pdData, remainingData] = otherData.reduce((acc, item) => {
                            const [same, pd, remaining] = acc;
                            
                            if (item.sensor_type === currentType) {
                                same.push(item);
                            } else if (pdTypes.includes(item.sensor_type)) {
                                pd.push(item);
                            } else {
                                remaining.push(item);
                            }
                            
                            return acc;
                        }, [[], [], []]);

                        this.dataDetails = [].concat(
                            currentSensorData,
                            sameType,
                            pdData,
                            remainingData
                        );

                        this.showChartDetails = true;
                        outLoading.close();
                    });
                }).catch(err => {
                    outLoading.close();
                    console.log('请求事件详情出错：', err);
                });
            } catch(err) {
                outLoading.close();
                console.log('请求事件数据出错：', err);
            }
        },
        // 事件列表相关方法
        queryEventList() {
            if (this.currentNodeInfo.type == 'customer') {
                this.getEventCustomerList(this.currentNodeInfo.id)
            } else if (this.currentNodeInfo.type == 'site') {
                this.getEventSiteList(this.currentNodeInfo.id)
            } else if (this.currentNodeInfo.type == 'equipment') {
                this.getEventEquipmentList(this.currentNodeInfo.id)
            }
        },
        getEventCustomerList(id) {
            eventApi.customerEventList({ customer_id: id, data: Object.assign(this.eventSearchForm, { page: this.eventCurrentPage, limit: this.eventSize }) }).then(res => {
                this.loading = false;
                this.eventTableData = res.data.event_list;
                this.eventTotal = res.data.total;
            }).catch((err) => {
                this.loading = false
            })
        },
        getEventSiteList(id) {
            eventApi.siteEventList({ site_id: id, data: Object.assign(this.eventSearchForm, { page: this.eventCurrentPage, limit: this.eventSize }) }).then(res => {
                this.loading = false;
                this.eventTableData = res.data.event_list;
                this.eventTotal = res.data.total;
            }).catch((err) => {
                this.loading = false
            })
        },
        getEventEquipmentList(id) {
            eventApi.equipmentEventList({ equipment_id: id, data: Object.assign(this.eventSearchForm, { page: this.eventCurrentPage, limit: this.eventSize }) }).then(res => {
                this.loading = false;
                this.eventTableData = res.data.event_list;
                this.eventTotal = res.data.total;
            }).catch((err) => {
                this.loading = false
            })
        },
        handleEventSizeChange(val) {
            this.eventSize = val;
            this.queryEventList();
        },
        handleEventCurrentChange(val) {
            this.eventCurrentPage = val;
            this.queryEventList();
        },
        selectEventDate() {
            if (this.eventDateRange) {
                this.eventSearchForm.start_date = this.formatDate(this.eventDateRange[0])
                this.eventSearchForm.end_date = this.formatDate(this.eventDateRange[1]);
            } else {
                this.eventSearchForm.start_date = this.eventSearchForm.end_date = ""
            }
        },
        doEventReset() {
            this.eventDateRange = [];
            this.eventSearchForm.point_name = '';
            this.eventSearchForm.start_date = '';
            this.eventSearchForm.end_date = '';
            this.eventSearchForm.alarm_level = '';
            this.eventSearchForm.sensor_type = '';
            this.eventCurrentPage = 1;
            this.queryEventList();
        },
        // 自检列表相关方法
        isSelfCheckSuccess(row) {
            return row.online_status === 1 && row.sampling_check_status === 1;
        },
        buildSelfCheckParams() {
            const obj = this.currentNodeInfo;
            const params = Object.assign({}, this.selfCheckSearchForm, {
                page: this.selfCheckCurrentPage,
                limit: this.selfCheckSize
            });
            if (obj.type == 'customer') {
                params.company_id = obj.id;
            } else if (obj.type == 'site') {
                params.site_id = obj.id;
            } else if (obj.type == 'equipment') {
                params.equipment_id = obj.id;
            }
            return params;
        },
        querySelfCheckList() {
            if (!this.currentNodeInfo || !this.currentNodeInfo.type) {
                return;
            }
            this.loading = true;
            warning.selfCheckStatusList({ data: this.buildSelfCheckParams() }).then(res => {
                this.loading = false;
                this.selfCheckTableData = res.data.self_check_status || [];
                this.selfCheckTotal = res.data.total || 0;
            }).catch(() => {
                this.loading = false;
            });
        },
        handleSelfCheckSizeChange(val) {
            this.selfCheckSize = val;
            this.querySelfCheckList();
        },
        handleSelfCheckCurrentChange(val) {
            this.selfCheckCurrentPage = val;
            this.querySelfCheckList();
        },
        resetSelfCheckForm() {
            this.selfCheckSearchForm.site_name = '';
            this.selfCheckSearchForm.equipment_name = '';
            this.selfCheckSearchForm.point_name = '';
            this.selfCheckSearchForm.sensor_type = '';
            this.selfCheckSearchForm.online_status = '';
            this.selfCheckSearchForm.sampling_check_status = '';
            this.selfCheckSearchForm.health_status = '';
        },
        doSelfCheckReset() {
            this.resetSelfCheckForm();
            this.selfCheckCurrentPage = 1;
            this.querySelfCheckList();
        },
        // 事件导出
        handleEventExport() {
            const start_date = this.exportForm.timeRange[0]
            const end_date = this.exportForm.timeRange[1]
            let obj = this.currentNodeInfo
            this.currentKey = obj.id
            let params = {}
            if (obj.type == "customer") {
                params = {
                    customer_id: obj.id,
                    data: {
                        start_date: start_date,
                        end_date: end_date
                    }
                }
            } else if (obj.type == "site") {
                params = {
                    customer_id: obj.parent_id,
                    data: {
                        start_date: start_date,
                        end_date: end_date,
                        site_id: obj.id
                    }
                }
            } else if (obj.type == "equipment") {
                let customer_id;
                this.treeData.forEach(item => {
                    item.children.forEach(site => {
                        if (site.id == obj.parent_id) {
                            customer_id = item.id;
                        }
                    })                    
                })
                params = {
                    customer_id: customer_id,
                    data: {
                        start_date: start_date,
                        end_date: end_date,
                        equipment_id: obj.id
                    }
                }
            }
            eventApi.exportEventData(params).then((res) => {
                return res
            }).catch(err => {
                console.error('导出失败', err);
                this.$message.error('此时间段无数据！');
            }).finally(() => {
                this.showEventExportDialog = false;
                this.exportForm = { /* 重置表单 */ };
            });
        }
    }
}
</script>

<style lang='less' scoped>
.el-form-item {
    margin-bottom: 0;
    white-space: nowrap;
    padding-right: 80px;
}

/deep/.el-form-item__label {
    white-space: nowrap;
    width: 100px;
    color: #ffffff;
    text-align: right;
}

.left-tree {
    background: #2C2E30;
    height: calc(100% - 160px);
    color: #fff;
}

.btn-group {
    float: right;
}

.el-button--small {
    padding: 9px 35px;
}

.main-area {
    width: calc(100% - 300px);
    float: right;
}

.small-btn{
    height:36px;
    background:rgb(32, 52, 49);
    border:solid 1px rgb(121,121,121);
    color:#fff;
    border-radius: 5px;
    cursor: pointer;
}

/deep/.el-button+.el-button{
    margin-left:0;
}

/deep/.left-tree .el-tree {
    background: #2C2E30;
    color: #fff;
    user-select: none;
}

/deep/.warning-tabs {
    width: 100%;
    text-align: center;
    position: relative
}

/deep/.site-tabs-ul.el-tabs {
    width: 600px;
    position: absolute;
    left: 0;
    right: 0;
    margin: auto;
    top: 0;
}

/deep/.el-tabs__nav-wrap::after {
    height: 0;
}

/deep/.el-tabs__active-bar {
    height: 0;
    ;
}

/deep/.site-tabs-ul .el-tabs__item {
    font-size: 18px;
    background: #2C2E30;
    margin-right: 2px;
    width: 130px;
    padding: 0;
}

/deep/.el-table tbody tr:hover>td {
    background: #3d3f44 !important;
}

/deep/.el-table__body tr.current-row>td.el-table__cell{
  background: #3d3f44 !important;
}

/deep/.el-range-input {
    background: transparent
}

/deep/.el-date-editor .el-range__close-icon {
    line-height: 25px;
}

/deep/.el-pagination {
    position: absolute;
    text-align: center;
    bottom: 0;
    left: 0;
    right: 0;
    margin: 0 auto;

    .el-input__inner {
        background: #2C2E30;
        border: 0;
        color: #fff;
    }

    .btn-prev,
    .btn-next {
        background: #2C2E30;
    }

    .el-pager li {
        background: #2C2E30;
    }
}

.table-content {
    position: relative;
    height: calc(100% - 100px);

    .el-table {
        height: calc(100% - 40px);
        overflow: auto;
    }
}

.tree-div {
    height: calc(100% - 40px)
}

.search-content{
  height: 140px;
}

.stat-card {
    display: flex;
    align-items: center;
    background: linear-gradient(135deg, #2C2E30 0%, #3d3f44 100%);
    border-radius: 12px;
    padding: 10px 12px;
    margin-bottom: 10px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
    border: 1px solid #444648;
}

.stat-icon {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    background: linear-gradient(135deg, #ff6b6b 0%, #ee5a24 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 24px;
    animation: pulse 2s ease-in-out infinite;

    .el-icon-bell {
        font-size: 28px;
        color: #fff;
    }
}

@keyframes pulse {
    0%, 100% {
        transform: scale(1);
        opacity: 1;
    }
    50% {
        transform: scale(1.05);
        opacity: 0.9;
    }
}

.stat-info {
    display: flex;
    flex-direction: column;
}

.stat-label {
    font-size: 14px;
    color: #999;
    margin-bottom: 8px;
    letter-spacing: 1px;
}

.stat-value-wrap {
    display: flex;
    align-items: baseline;
}

.stat-value {
    font-size: 40px;
    font-weight: 700;
    color: #ff6b6b;
    line-height: 1;
    margin-right: 8px;
    font-family: 'Arial', sans-serif;
}

.stat-unit {
    font-size: 16px;
    color: #666;
}

/deep/.el-input__inner {
    background: #2C2E30;
    border: 1px solid #444648;
    color: #fff;
}

/deep/.el-select .el-input__inner {
    background: #2C2E30;
    border: 1px solid #444648;
}

/deep/.el-date-editor {
    background: #2C2E30;
    border: 1px solid #444648;
    width: 320px;
}
/deep/.el-date-editor .el-range-input {
    background: #2C2E30;
    color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/view/warning/warning.vue